export default getWebAnalyticsContainer;

function getWebAnalyticsContainer() {
	if (window.DATALAYER_RESTRUCTURING_ENABLED) {
		window.dataLayer = window.dataLayer || [];
		return window.dataLayer;
	} else {
		window.newDataLayer = window.newDataLayer || [];
		return window.newDataLayer;
	}
}
